import { Input } from "shared/components/forms/Input";
import { DateInput, Select } from "shared/components";
import { useAuthContext } from "providers/Auth";
import { SectionCard } from "shared/app/SectionCard";

const statusOptions = [
  { value: false, label: "Available" },
  { value: true, label: "Occupied" }
];

interface RentalInfoFormProps {
  register: any;
  headerExtra?: React.ReactNode;
  footer?: React.ReactNode;
  canChangeAvailablebyDate?: boolean;
  canChangeRentAmount?: boolean;
}

export const RentalInfoForm = (props: RentalInfoFormProps) => {
  const {
    register,
    headerExtra,
    footer,
    canChangeAvailablebyDate = true,
    canChangeRentAmount = true
  } = props;

  const { pms, type } = useAuthContext();
  const homeSiteRentEnabled = pms.isManageAmerica || type.isHomeSiteRentEnabled;
  return (
    <SectionCard
      title="Rental information"
      headerExtra={headerExtra}
      footer={footer}
    >
      <div className="divide-y divide-alpha-40">
        <div className="grid grid-cols-2 gap-4 pb-4">
          {homeSiteRentEnabled ? (
            <>
              <div className="money-input-2 w-full">
                <Input
                  id="homeRentAmount"
                  label="Home rent"
                  placeholder="1,500"
                  type="money"
                  required
                  disabled={!canChangeRentAmount}
                  {...register(
                    "home_rent_amount",
                    (value) => value || undefined
                  )}
                />
              </div>
              <div className="money-input-2 w-full">
                <Input
                  id="siteRentAmount"
                  label="Site rent"
                  placeholder="1,500"
                  type="money"
                  required
                  disabled={!canChangeRentAmount}
                  {...register(
                    "site_rent_amount",
                    (value) => value || undefined
                  )}
                />
              </div>
            </>
          ) : (
            <div className="money-input-2 w-full">
              <Input
                id="monthlyRentAmount"
                label="Rent amount"
                placeholder="1,500"
                type="money"
                required
                disabled={!canChangeRentAmount}
                {...register(
                  "monthly_rent_amount",
                  (value) => value || undefined
                )}
              />
            </div>
          )}
        </div>

        <div className="grid grid-cols-2 gap-4 pt-4">
          <div>
            <Select
              id="current-status"
              label="Current status"
              options={statusOptions}
              required
              {...register("occupied")}
              disabled={!canChangeAvailablebyDate}
            />
          </div>

          <div>
            <DateInput
              id="available_at"
              label="Available by date"
              required
              readOnly={
                !register("occupied").value || !canChangeAvailablebyDate
              }
              {...register("available_at")}
            />
          </div>
        </div>
      </div>
    </SectionCard>
  );
};
